(() => {
  const container = document.querySelector('[data-pdp-related]');
  const root = document.querySelector('[data-pdp-root]');
  if (!container || !root) return;

  const productId = root.dataset.productId;
  if (!productId) return;

  const params = new URLSearchParams({
    product_id: productId,
    limit: '10',
    intent: 'related',
    section_id: 'pdp-related',
  });

  window.addEventListener('load', () => {
    fetch(`${window.Shopify?.routes?.root ?? '/'}recommendations/products?${params.toString()}`)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html.trim()) return;
        container.innerHTML = html;
        container.hidden = false;
        container.dispatchEvent(new CustomEvent('wowthings:content:load', { bubbles: true }));
      })
      .catch(() => {});
  });
})();
